import { ImageMedia } from '../../services/getMediaFilesApi'

export const removeDuplicatePhotos = (
  mediaFiles: ImageMedia[],
): ImageMedia[] => {
  const seenUrls = new Set<string>()
  return mediaFiles.filter((mediaFile) => {
    if (!seenUrls.has(mediaFile.url)) {
      seenUrls.add(mediaFile.url)
      return true
    }
    return false
  })
}
